import React from 'react';
import { DialogShell } from './ui/DialogShell';

interface MiembroFotoLightboxProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly fotoUrl: string;
  readonly nombreCompleto: string;
}

export const MiembroFotoLightbox: React.FC<MiembroFotoLightboxProps> = ({
  isOpen,
  onClose,
  fotoUrl,
  nombreCompleto
}) => (
  <DialogShell isOpen={isOpen} onClose={onClose} size="sm" level="nested" title={nombreCompleto}>
    <img
      src={fotoUrl}
      alt={`Foto de ${nombreCompleto}`}
      className="w-full max-h-[70vh] rounded-xl object-contain"
    />
  </DialogShell>
);
